module.exports = __webpack_public_path__ + "media/images/top/flow01-a8b70a439815a52809aaaa554fb28bdc.jpg";